export default __webpack_public_path__ + "static/media/safe-skies.f11825c9.jpg";